import { AddSocketDtoSocketTypeEnum, Order, Product, ProductLineItem, ProductTypeEnum } from 'src/app/api-client';

export function isSingleSocket(item: ProductLineItem | Product) {
  return item.productNumber.startsWith('arsod');
}

export function isForkliftSocket(item: ProductLineItem | Product) {
  return item.productNumber.startsWith('arsou');
}

export function isSocketAvailable(socketType: AddSocketDtoSocketTypeEnum, order: Order): boolean {
  const singleSocketDepths = ['300', '400', '500'];
  const singleSocketWidths = ['600', '700', '800', '900', '1000', '1100', '1200', '1300', '1400', '1500', '1600'];

  const forkliftSocketDepths = ['300', '400', '500', '600'];
  const forkliftSocketWidths = ['600', '700', '800', '900', '1000', '1100', '1200', '1300', '1400', '1500', '1600'];

  if (order.productType !== ProductTypeEnum.Ars) return true;
  if (socketType === 'DEFAULT') return true;

  if (socketType === 'SINGLE') {
    let depthAvailable = singleSocketDepths.includes(order.depth.toString());
    let fields = order.lineItems.filter((l) => l.isField);
    let widthAvailable =
      fields.length < 2 && fields[0]?.width != null && singleSocketWidths.includes(fields[0].width.toString());

    if (depthAvailable && widthAvailable) {
      return true;
    }
  }

  if (socketType === 'FORKLIFT') {
    let depthAvailable = forkliftSocketDepths.includes(order.depth.toString());
    let fields = order.lineItems.filter((l) => l.isField);
    let widthAvailable =
      fields.length < 2 && fields[0]?.width != null && forkliftSocketWidths.includes(fields[0].width.toString());

    if (depthAvailable && widthAvailable) {
      return true;
    }
  }

  return false;
}
